<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <div class="pa-4">
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="fields['title']" label="Name" />
              <div class="d-flex align-center gap-3">
                <input
                  style="width: 40px; height: 40px; margin-right: 12px"
                  type="color"
                  v-model="fields['containerBackground']"
                />
                <v-text-field v-model="fields['containerBackground']" label="Background Color" />
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <v-row>
            <v-col class="mb-7" cols="12">
              <label class="label-input">Header</label>
              <ckeditor :editor="editor" v-model="fields['header']" :config="editorConfig" />
            </v-col>
          </v-row>
          <div>
            <label class="label-input">Products</label>
            <v-row>
              <v-col cols="4">
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields['itemCommon'].background"
                  />
                  <v-text-field v-model="fields['itemCommon'].background" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="4">
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields['itemCommon'].color"
                  />
                  <v-text-field v-model="fields['itemCommon'].color" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="4">
                <v-text-field type="number" v-model="fields['itemCommon'].radius" label="Item Radius" />
              </v-col>
            </v-row>
            <div>
              <label class="label-input">Button</label>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="fields['itemCommon'].btnText" label="Button Text" />
                </v-col>
                <v-col cols="6">
                  <v-text-field type="number" v-model="fields['itemCommon'].btnRadius" label="Button Radius" />
                </v-col>
                <v-col cols="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields['itemCommon'].btnBg"
                    />
                    <v-text-field v-model="fields['itemCommon'].btnBg" label="Button Background Color" />
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields['itemCommon'].btnColor"
                    />
                    <v-text-field v-model="fields['itemCommon'].btnColor" label="Button Text Color" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div>
              <label class="label-input">Save Tag</label>
              <v-row>
                <v-col cols="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields['itemCommon'].saveBg"
                    />
                    <v-text-field v-model="fields['itemCommon'].saveBg" label="Save Background Color" />
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields['itemCommon'].saveColor"
                    />
                    <v-text-field v-model="fields['itemCommon'].saveColor" label="Save Text Color" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div>
              <div class="d-flex justify-space-between align-center">
                <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                  <label class="label-input" style="margin-bottom: 0">Product items</label>
                </div>
                <v-btn small text color="primary" @click="handleAddProductItem">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span>Add Product Item</span>
                </v-btn>
              </div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <label>Product Item {{ i + 1 }}</label>
                      <v-btn icon @click.stop="handleRemoveProductItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <div class="mb-5">
                        <UploadImage
                          :image="{ imageSrc: item.image }"
                          :height="`400`"
                          :typeUpload="'image'"
                          @callback="obj => handleUploadImage(obj, i)"
                          @callbackDelete="handleRemoveUploadImage(i)"
                        />
                      </div>
                      <div>
                        <label style="font-weight: bold;">Link</label>
                        <v-text-field v-model="item.link" />
                      </div>
                      <div class="mb-5">
                        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                          <label for="showRating" style="margin-bottom: 0; font-weight: bold;">Rating</label>
                          <input type="checkbox" v-model="item.showRating" id="showRating" />
                        </div>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-rating
                              color="warning"
                              background-color="#c1c1c1"
                              empty-icon="mdi-star-outline"
                              full-icon="mdi-star"
                              half-icon="mdi-star-half-full"
                              hover
                              length="5"
                              size="35"
                              :value="item.ratingStars"
                              @input="value => handleChangeRatingStars(value, i)"
                            ></v-rating>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-text-field v-model="item.ratingText" label="Text" />
                          </v-col>
                        </v-row>
                      </div>
                      <div class="mb-5">
                        <label class="mb-3" style="font-weight: bold;">Name</label>
                        <ckeditor :editor="editor" v-model="item.headerItem" :config="editorConfig" />
                      </div>
                      <div class="mb-5">
                        <label style="font-weight: bold;">Price</label>
                        <v-row>
                          <v-col cols="3">
                            <v-text-field
                              type="number"
                              @input="value => handleChangePriceNew(value, i)"
                              :value="item.priceNew"
                              label="New Price"
                            />
                          </v-col>
                          <v-col cols="3">
                            <v-text-field
                              type="number"
                              @input="value => handleChangePriceOld(value, i)"
                              :value="item.priceOld"
                              label="Old Price"
                            />
                          </v-col>
                          <v-col cols="6">
                            <div class="d-flex align-center gap-3">
                              <!-- <input type="checkbox" v-model="item.showSave" id="showSave" /> -->
                              <v-checkbox v-model="item.showSave" label="" />
                              <v-text-field v-model="item.priceSale" label="Sale Price" />
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

export default {
  name: 'ProductsSlider',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        containerBackground: '#ffffff',
        header: '',
        listItem: [],
        itemCommon: {
          showRating: false,
          background: '#f6f6f6',
          color: '#000000',
          radius: '10',
          saveBg: '#6293c1',
          saveColor: '#FFFFFF',
          btnBg: '#6293c1',
          btnColor: '#FFFFFF',
          btnRadius: '10',
          btnText: 'Show Now',
          link: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleChangePriceNew(value, i) {
      console.log(value, 'value');
      this.fields['listItem'][i].priceNew = value;
      if (value > this.fields['listItem'][i].priceOld || value < 0 || value === '') return;
      let save = ((this.fields['listItem'][i].priceOld - value) / this.fields['listItem'][i].priceOld) * 100;
      save = save.toFixed(0);
      this.fields['listItem'][i].priceSale = this.changeTextSave(save, this.fields['listItem'][i].priceSale);
    },
    handleChangePriceOld(value, i) {
      this.fields['listItem'][i].priceOld = value;
      if (value < this.fields['listItem'][i].priceNew || value < 0 || value === '') return;
      let save = ((value - this.fields['listItem'][i].priceNew) / value) * 100;
      save = save.toFixed(0);
      this.fields['listItem'][i].priceSale = this.changeTextSave(save, this.fields['listItem'][i].priceSale);
    },
    handleAddProductItem() {
      this.fields['listItem'].push({
        image: null,
        showRating: true,
        ratingStars: 5,
        ratingText: '1.095 Reviews',
        headerItem: '<h2>Hugterra™ Massager</h2><p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>',
        showPrice: true,
        priceNew: 139,
        priceOld: 300,
        priceSale: 'Save 50%',
        showSave: true,
        btnViewMore: 'Show Now',
        link: '#',
      });
    },
    handleUploadImage(obj, i) {
      this.fields['listItem'][i].image = obj.imageSrc;
    },
    handleRemoveUploadImage(i) {
      this.fields['listItem'][i].image = null;
    },
    handleRemoveProductItem(i) {
      this.fields['listItem'].splice(i, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionProductsSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    handleChangeRatingStars(value, i) {
      const num = Number(value);
      this.fields['listItem'][i].ratingStars = num;
    },

    changeTextSave(value, text) {
      if (!text) text = 'Save 50%';
      if (value < 0 || value === '') return text;

      return text.replace(/\d+(\.\d+)?/, `${value}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-title-card {
  ::v-deep(.ck-editor__editable_inline) {
    min-height: 150px;
  }
  ::v-deep(.ck-editor__editable) {
    min-height: 150px;
  }
}
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  //   border-bottom: 1px dashed #0081c7;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  //   border-top: 1px solid #0081c7;
  box-shadow: 0px 0px 12px #0000000f;
}
.v-color-picker__controls {
  padding-bottom: 11px;
}
.v-expansion-panels {
  border: 1px solid #c1c1c1;
  // border-radius: 10px;
  // overflow: hidden;
}
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
